import type { ReactNode } from 'react'

import { MdClose, MdLink } from 'react-icons/md'
import { Link } from 'react-router-dom'

import { useSidebar } from '../../context'

interface HeaderProps {
  children: ReactNode
  link?: string
  linkTitle?: string
}

export function Header ({ children, link, linkTitle }: HeaderProps): JSX.Element {
  let sidebar = useSidebar()
  return (
    <div
      className='flex flex-row justify-between items-center pt-6 px-4 text-xs font-medium uppercase text-[#626F86] tracking-wider'
    >
      <span style={{ fontFamily: 'Roboto, sans-serif' }}>{children}</span>
      <div className='flex flex-row gap-3'>
        {link && (
          <Link
            className='flex text-gray-400 hover:text-gray-700'
            to={link}
            title={linkTitle}
          >
            <MdLink
              size={24}
              className='text-inherit'
            />
          </Link>
        )}
        <button
          className='cursor-pointer flex text-gray-400 hover:text-gray-700'
          onClick={() => {
            sidebar.close()
          }}
          title='Close panel'
        >
          <MdClose
            size={24}
          />
        </button>
      </div>
    </div>
  )
}
